<template>
	<modal-component class="scrollable-modal-container product-order-count-dialog"
					 v-if="modalComponentShown"
					 :onClose="onClose"
					 :buttons="buttons"
					 :classes="'modal-small'"
	>
		<v-flex xs12 class="dialog-header">
			{{$t("admin.products.productOrderCountDialog.mealCounter") }}
		</v-flex>
		<v-container v-if="loadingCount">
			<v-progress-circular indeterminate/>
		</v-container>
		<v-container v-else-if="productOrderSum === 0">
			<v-layout row wrap class="title-no-orders">
				<v-flex xs12 class="bold">
					{{$t("admin.products.productOrderCountDialog.newYear")}}
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap class="title-wrapper">
				<v-flex xs8 class="bold">
					{{$t("admin.products.productOrderCountDialog.productName") }}
				</v-flex>
				<v-flex xs4 class="bold">
					{{$t("admin.products.productOrderCountDialog.count") }}
				</v-flex>
			</v-layout>
			<template v-for="count in productOrderCount" v-if="productOrderSum > 0">
				<v-layout row wrap>
					<v-flex xs8 class="text-product">
						{{ count.productName }}
					</v-flex>
					<v-flex xs4 class="text-count">
						{{ count.count }}
					</v-flex>
				</v-layout>
			</template>
		</v-container>
	</modal-component>
</template>

<script>
	import ModalComponent from "../../UtilityComponents/ModalComponent";
	import ProductOrderCountProvider from "../../../providers/ProductOrderCountProvider";

	export default {
		name: "ProductOrderCountDialog",
		props: ["modalComponentShown", "closeCallback"],
		components: {
			ModalComponent
		},
		data() {
			const self = this;

			return {
				onClose: self.closeCallback,
				productOrderCount: [],
				loadingCount: false,
				productOrderSum: 0
			};
		},
		computed: {
			buttons() {
				const self = this;
				return {
					luk: self.closeCallback
				};
			}
		},
		watch: {
			async modalComponentShown() {
				const self = this;
				if (self.modalComponentShown === true) {
					self.loadingCount = true;
					self.productOrderCount = await ProductOrderCountProvider.findProductOrderCount();
					self.productOrderSum = self.productOrderCount.reduce((sum, productOrderCount) => sum + productOrderCount.count, 0);
					self.loadingCount = false;
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.bold {
		font-weight: bold;
	}
	.dialog-header {
		height: 70px;
		background-color: #5394b6;
		color: #ffffff;
		font-size: 24px;
		font-weight: bold;
		font-style: normal;
		font-stretch: normal;
		line-height: normal;
		letter-spacing: -0.86px;
		text-align: center;
		padding: 22px;
	}
	.container {
		padding: 30px 112px;
		.title-wrapper {
			font-size: 26px;
			font-weight: 300;
			font-style: normal;
			font-stretch: normal;
			line-height: normal;
			letter-spacing: -1.15px;
			text-align: left;
			color: #838383;
			margin-bottom: 8px;
		}
		.text-product {
			font-size: 20px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 2.1;
			letter-spacing: normal;
			color: #868686;
		}
		.text-count {
			font-size: 20px;
			font-weight: bold;
			font-style: normal;
			font-stretch: normal;
			line-height: 2.1;
			letter-spacing: normal;
			color: #868686;
		}
		.title-no-orders {
			font-size: 22px;
			font-weight: 300;
			font-style: normal;
			font-stretch: normal;
			line-height: normal;
			letter-spacing: -1.15px;
			text-align: left;
			color: #838383;
		}
	}
</style>
